import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';

import type { PayrollSharingStatus } from './payroll-sharing.models';

@Injectable({ providedIn: 'root' })
export class PayrollSharingStatusApiService {
  #gateway = inject(ApiGateway);
  #endpoint = 'hiring/settings/payroll-sharing-status';

  // 404s by design while the payroll-flow feature flags are off — consumers hide their UI, never toast.
  get() {
    return this.#gateway.get<PayrollSharingStatus>(this.#endpoint, {
      headers: { ignoreMetaMessage: true },
    });
  }
}
